import styled from 'styled-components';
import { useState } from 'react';

import { IconButton } from '@/ui/Button';
import { Chip } from '@/ui/Chip/atoms/Chip';
import { useRemoveUsersFromLearningJourneyCohortMutationRemote } from '@/store/v2';
import { JourneyInsightsBulkParticipantsRemovalModal } from '@/features/journey/admin/atoms/JourneyInsightsBulkParticipantsRemovalModal';

const RootStyled = styled.div`
  ${({ theme }) => theme.shadow.primary[64]};
  position: fixed;
  bottom: 24px;
  left: 50%;
  border-radius: 8px;
  padding: 16px;
  transform: translateX(-50%);
  background: ${({ theme }) => theme.colors.neutral.container};
  color: ${({ theme }) => theme.colors.neutral.onContainer};
`;

const ParticipantsCounterStyled = styled.div`
  ${({ theme }) => theme.typography.body2};
`;

const ContentStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding-left: 16px;
`;

const Divider = styled.div`
  width: 1px;
  background: ${({ theme }) => theme.colors.neutral.outline1};
  height: 36px;
`;

const ActionsStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const JourneyInsightsSelectedParticipantsFloatingBar = ({
  selectedParticipantsIds,
  onDiscardClick,
  journeyId,
}: {
  selectedParticipantsIds: number[];
  onDiscardClick: () => void;
  journeyId: number;
}): JSX.Element => {
  const [isRemoveConfirmationModalOpen, setIsRemoveConfirmationModalOpen] = useState(false);
  const [removeUsers, { loading }] = useRemoveUsersFromLearningJourneyCohortMutationRemote();

  const handleDeleteSelectedParticipants = async () => {
    await removeUsers({
      variables: {
        journeyId,
        userIds: selectedParticipantsIds,
      },
      update(cache, { data }) {
        if (data?.removeUsersFromLearningJourneyCohort?.success) {
          onDiscardClick();

          cache.evict({ fieldName: 'reportingMyLearningJourneysLearners' });
          cache.evict({ fieldName: 'reportingMyLearningJourneysLearnersTotalCount' });
          cache.evict({ fieldName: 'reportingMyLearningJourneysInsightsV2' });
        }
      },
    });
  };

  return (
    <>
      <JourneyInsightsBulkParticipantsRemovalModal
        open={isRemoveConfirmationModalOpen}
        onClose={() => setIsRemoveConfirmationModalOpen(false)}
        onDelete={handleDeleteSelectedParticipants}
        deleteLoading={loading}
      />
      <RootStyled>
        <ContentStyled>
          <ParticipantsCounterStyled>{selectedParticipantsIds.length} learners selected</ParticipantsCounterStyled>
          <Divider />
          <ActionsStyled>
            <Chip leadingIcon={['far', 'trash']} onClick={() => setIsRemoveConfirmationModalOpen(true)}>
              <>Delete</>
            </Chip>
          </ActionsStyled>
          <IconButton icon="xmark" onClick={onDiscardClick} />
        </ContentStyled>
      </RootStyled>
    </>
  );
};
